import {
  DATE_DISPLAY_FORMAT,
  DATE_TIME_DISPLAY_FORMAT,
  MONTH_YEAR_DISPLAY_FORMAT,
} from '../../../../constants';

import type { Moment } from 'moment';
import type { FDateTimePickerProps } from '../types';

export function getPickerFormat(
  format: FDateTimePickerProps['format'],
  dateOnly: boolean,
  picker: FDateTimePickerProps['picker'],
): NonNullable<FDateTimePickerProps['format']> {
  if (format != null) {
    return format;
  }
  if (picker === 'month') {
    return MONTH_YEAR_DISPLAY_FORMAT;
  }
  return dateOnly ? DATE_DISPLAY_FORMAT : DATE_TIME_DISPLAY_FORMAT;
}

export function formatDateTimePickerValue(
  value: Moment | null | undefined,
  format: FDateTimePickerProps['format'],
  dateOnly: boolean,
  picker: FDateTimePickerProps['picker'],
): string {
  if (value == null) {
    return '';
  }

  const resolvedFormat = getPickerFormat(format, dateOnly, picker);
  const displayFormat = Array.isArray(resolvedFormat) ? resolvedFormat[0] : resolvedFormat;

  if (typeof displayFormat === 'function') {
    return displayFormat(value);
  }

  if (typeof displayFormat === 'string') {
    return value.format(displayFormat);
  }

  if (picker === 'month') {
    return value.format(MONTH_YEAR_DISPLAY_FORMAT);
  }
  return value.format(dateOnly ? DATE_DISPLAY_FORMAT : DATE_TIME_DISPLAY_FORMAT);
}
